import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { t } from '../../../../locales';
import { hideModal } from '../../../../actions/uiActions';
import { goto } from '../../../../actions/historyActions';

// import image
import illusHealthChallenges from '../../../../assets/images/aktivo/illusHealthChallenges.png';
import illusMyWellness from '../../../../assets/images/aktivo/illusMyWellness.png';

//import Action
import HomePagePopUpRegistry from '../../../../registries/HomePagePopUpRegistry';
import { EMMA_AXA_GOAL } from '../../../../constants/constants';
import './styles.scss';
import { addCorpWebIndicator } from '../../../../utils/emmaUrlConverter';
import {
  trackNavigationOverlayClicked,
  trackNavigationOverlayDisplay,
} from '../../../../utils/generalGaEventAnalytics';
import { getCorpWebIndicatorConfig } from '../../../emma-webview/selectors/webviewSelector';
import {
  triggerPopupDisplayScreenChange,
  triggerPopupCloseScreenChange,
} from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaPreviousScreenUtil';
import {
  getAktivoOnboardingConfig,
  getEmmaAppDownloadPath,
} from '../../selectors/aktivoOnboardingSelectors';
import { toggleAktivoModelDisplay } from '../../actions';
import { getAxaGoalInsuredPolicies } from '../../../../selectors/userSelectors';
interface AktivoModalViewProps {
  downAppLink: string;
  toggleAktivoModal: (toggle: boolean) => void;
  hideModal: () => void;
  showAktivoModal: boolean;
  isAxaGoal: boolean;
}

class AktivoModalView extends Component<AktivoModalViewProps> {
  constructor(props: any) {
    super(props);
    this.closeAktivoModal = this.closeAktivoModal.bind(this);
  }

  closeAktivoModal() {
    HomePagePopUpRegistry.setIsShowPopupCompleted(EMMA_AXA_GOAL); //will be dispatch next banner
    this.props.toggleAktivoModal(false);
    this.props.hideModal();
    triggerPopupCloseScreenChange();
  }

  onClickRuleBtn() {
    const { isAxaGoal } = this.props;
    const btnText = t('VHIS_MODAL_LINK');
    if (isAxaGoal) {
      goto('aktivo-onboarding/axa-goal/rules');
    } else {
      goto('aktivo-onboarding/my-wellness/rules');
    }
    trackNavigationOverlayClicked(btnText, 'AXA Goal Intro Popup');
    this.closeAktivoModal();
  }

  onClickGetStartedBtn() {
    const btnText = t('VHIS_MODAL_BTN');
    trackNavigationOverlayClicked(btnText, 'AXA Goal Intro Popup');
  }

  render() {
    const { downAppLink, showAktivoModal, isAxaGoal } = this.props;
    return (
      <div>
        {showAktivoModal && (
          <div className="aktivo-modal-container">
            <div className="aktivo-modal__content">
              <button
                className="aktivo-modal__close"
                onClick={() => this.closeAktivoModal()}
                data-enable-ga
                data-ga-type="button"
              >
                {t('CLOSE')}
              </button>
              <img
                className="aktivo-modal__content__img"
                src={isAxaGoal ? illusHealthChallenges : illusMyWellness}
                alt="illustrations"
              />
              <p
                className="aktivo-modal__content__txt__title"
                dangerouslySetInnerHTML={{
                  __html: memoSanitize(
                    isAxaGoal ? t(`AXA_GOAL_TITLE`) : t(`MY_WELLNESS_TITLE`),
                  ),
                }}
              ></p>
              {isAxaGoal && (
                <p
                  className="aktivo-modal__content__txt__subtitle"
                  dangerouslySetInnerHTML={{
                    __html: memoSanitize(t(`VHIS_MODAL_SUBTITLE`)),
                  }}
                ></p>
              )}
              <p
                className="aktivo-modal__content__txt aktivo-modal__content__txt__content"
                dangerouslySetInnerHTML={{
                  __html: memoSanitize(
                    isAxaGoal
                      ? t(`VHIS_MODAL_CONTENT`)
                      : t(`MY_WELLNESS_MODAL_CONTENT`),
                  ),
                }}
              ></p>
              <div className="aktivo-modal__content__app-dl-btn">
                <a
                  className="aktivo__btn aktivo__btn--blue"
                  href={downAppLink}
                  target="_blank"
                  data-enable-ga
                  data-ga-type="link"
                  onClick={() => {
                    this.onClickGetStartedBtn();
                  }}
                  rel="noreferrer"
                >
                  {t('VHIS_MODAL_BTN')}
                </a>
              </div>
              <div className="aktivo-modal__content__txt">
                <div
                  className="aktivo-modal__content__link aktivo-modal__content__link--mobile-btn"
                  onClick={() => {
                    this.onClickRuleBtn();
                  }}
                  data-enable-ga
                  data-ga-type="button"
                >
                  {isAxaGoal
                    ? t('VHIS_MODAL_LINK')
                    : t('MY_WELLNESS_MODAL_LINK')}
                </div>
              </div>
            </div>
            <div
              className="aktivo-modal__bg"
              onClick={() => this.closeAktivoModal()}
              data-enable-ga
              data-ga-type="button"
            ></div>
          </div>
        )}
      </div>
    );
  }

  static mapStateToProps(state: any) {
    const { showAktivoModal } = getAktivoOnboardingConfig(state);
    const axaGoalInsuredPolicies = getAxaGoalInsuredPolicies(state);
    const appLink = addCorpWebIndicator({
      url: getEmmaAppDownloadPath(state),
      ...getCorpWebIndicatorConfig(state),
    });
    return {
      showAktivoModal,
      downAppLink: appLink,
      isAxaGoal: !!axaGoalInsuredPolicies.length,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      toggleAktivoModal: (toggle: boolean) =>
        dispatch(toggleAktivoModelDisplay(toggle)),
      hideModal: () => dispatch(hideModal()),
    };
  }
}

export default connect(
  AktivoModalView.mapStateToProps,
  AktivoModalView.mapDispatchToProps,
)(AktivoModalView);
